export const identity = () => {
  console.debug("");
};

export function maybe(func, $this?) {
  if (func) {
    const boundFunc = func.bind($this);
    return (...args) => boundFunc(...args);
  }
  return identity;
}
